module.exports = __webpack_public_path__ + "static/04-6fc8e8f9b1681a6ca1caceb51b7a1eaf.jpg";